<template>
  <div>
    <!-- 新增/编辑的对话框 -->
    <el-dialog :title="title" :visible="visible" width="40%" :modal-append-to-body="false" append-to-body
      @close="handleClose">
      <el-form class="baseForm" ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="激活码名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入激活码名称" clearable maxlength="99" size="small"></el-input>
        </el-form-item>
        <!-- - 激活码会员类型 -->
        <el-form-item label="激活码会员类型" prop="memberTypeId">
          <el-select v-model="form.memberTypeId" placeholder="请选择激活码会员类型" clearable size="small">
            <el-option v-for="item in cdkeyMemberList.value" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- - 定价周期 -->
        <el-form-item label="定价周期" prop="salePeriod">
          <el-input v-model="form.salePeriod" clearable maxlength="99" size="small" placeholder="请输入数字"></el-input>
        </el-form-item>
        <el-form-item prop="salePeriodUnit">
          <!-- 定价周期单位:1-日,2-月,3-季,4-年 -->
          <el-select v-model="form.salePeriodUnit" clearable size="small" placeholder="请选择定价周期单位">
            <el-option label="日" :value="1"></el-option>
            <el-option label="月" :value="2"></el-option>
            <el-option label="季" :value="3"></el-option>
            <el-option label="年" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <!-- 售价 -->
        <el-form-item label="售价" prop="salePrice">
          <el-input v-model="form.salePrice" clearable maxlength="99" size="small" placeholder="请输入金额"></el-input>
        </el-form-item>
        <!-- 联运商品 -->
        <el-form-item label="联运商品" prop="unionGoodsId">
          <el-select @change="selectUnionGoods" v-model="form.unionGoodsId" placeholder="请选择联运商品" clearable size="small">
            <el-option v-for="item in unionGoodsList.value" :key="item.id" :label="item.goodsName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.unionGoodsId && form.unionGoodsId !== 0" label=" ">
          <span>{{ unionGoodsShow }}</span>
        </el-form-item>
        <!-- - 前端可见- 必选，单选-->
        <el-form-item label="前端可见" prop="frontVisible">
          <el-radio-group v-model="form.frontVisible">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 状态   - 必选，生效、失效-->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">生效</el-radio>
            <el-radio :label="0">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item label="备注" prop="descr">
          <el-input type="textarea" show-limit-word v-model="form.descr" clearable maxlength="9999" size="small"
            placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="save"> 确 定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import Message from "@/components/Message"
import { addActiveGoodsLocal } from "@/api/memberNew/activeGoods"

export default {
  name: "WebSaaSAdd",
  inject: ["cdkeyMemberList", "unionGoodsList", "getList"],
  computed: {
    title() {
      return this.optionType === "add" ? "新增激活码商品" : "编辑激活码商品";
    },
  },

  data() {
    return {
      visible: false,
      /** 操作类型 */
      optionType: "add",
      /** 表单数据 */
      form: {
        /** 激活码名称 */
        name: "",
        /** 激活码会员类型 */
        memberTypeId: "",
        /** 定价周期 */
        salePeriod: "",
        /** 定价周期单位 */
        salePeriodUnit: "",
        /** 售价 */
        salePrice: "",
        /** 前端可见 */
        frontVisible: "",
        /** 状态 */
        status: "",
        /** 备注 */
        descr: "",
      },
      /** 验证规则 */
      rules: {
        name: [
          { required: true, message: "请输入激活码名称", trigger: "blur" },
        ],
        memberTypeId: [
          {
            required: true,
            message: "请选择激活码会员类型",
            trigger: "change",
          },
        ],
        salePeriod: [
          // 定价周期只能输入正整数
          { required: true, message: "请输入定价周期", trigger: "blur" },
          {
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur",
          },
        ],
        salePeriodUnit: [
          { required: true, message: "请选择定价周期单位", trigger: "change" },
        ],
        // 售价只能输入正整数
        salePrice: [
          { required: true, message: "请输入售价", trigger: "blur" },

        ],
        frontVisible: [
          { required: true, message: "请选择前端可见", trigger: "change" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        descr: [{ required: false, message: "请输入备注", trigger: "blur" }],
      },
      /** 联运商品展示 */
      unionGoodsShow: "",
    };
  },

  methods: {
    /** 选择联运商品 */
    selectUnionGoods() {
      if (this.form.unionGoodsId && this.unionGoodsList.value) {
        console.log("选择联运商品", this.form.unionGoodsId);
        const unionGoods = this.unionGoodsList.value.find(
          (item) => item.id == this.form.unionGoodsId
        );
        console.log("联运商品", unionGoods);
        this.unionGoodsShow = unionGoods ? unionGoods.partnerName + ' ' + unionGoods.salePeriodDescr + ' ' + unionGoods.salePrice + '元' : "";
      } else {
        this.unionGoodsShow = "-";
      }

    },
    //^ ^--------------对话框内部-------------^ ^
    /** 保存 */
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log("表单数据", this.form);
          /** 判断是新增还是编辑 */
          if (this.optionType === "add") {
            console.log('是新增');
            const res = await this.add(this.form);
            console.log('新增的响应', res);
            if (res.code == 200) {
              Message.success('新增成功')
              /** 通知刷新列表 */
              this.getList()
            }
          } else {
            console.log('是编辑');
            const res = await this.edit(this.form);
            console.log('编辑的响应', res);
            if (res.code == 200) {
              Message.success('编辑成功')
              /** 通知刷新列表 */
              this.getList()
            }
          }


          this.hide();
        }
      });
    },
    /** 新增的方法 */
    async add(form) {
      const params = cloneDeep(form);
      /** 新增时 审核状态为 草稿 */
      params.reviewStatus = 1;
      const { data } = await addActiveGoodsLocal(params);
      console.log('新增的响应', data);
      return data
    },
    /** 编辑的方法 */
    async edit(form) {
      const params = cloneDeep(form);
      /** 新增时 审核状态为 草稿 */
      params.reviewStatus = 1;
      const { data } = await addActiveGoodsLocal(params);
      console.log('编辑的响应', data);
      return data
    },
    //^ ^--------------对话框自身相关-------------^ ^
    show(row, optionType) {
      if (optionType) {

        this.optionType = optionType | 'add'
      }
      if (row) {
        console.log('接收到的数据', row);
        this.form = cloneDeep(row);
        this.selectUnionGoods()
      }
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    /** 关闭对话框 */
    handleClose() {
      /** 重置表单数据 */
      this.form = {
        /** 激活码名称 */
        name: "",
        /** 激活码会员类型 */
        memberTypeId: "",
        /** 定价周期 */
        salePeriod: "",
        /** 定价周期单位 */
        salePeriodUnit: "",
        /** 售价 */
        salePrice: "",
        /** 前端可见 */
        frontVisible: "",
        /** 状态 */
        status: "",
        /** 备注 */
        descr: "",
      },
        this.unionGoodsShow = "";
      /** 清除表单验证规则 */
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.baseForm {
  ::v-deep .el-input {
    width: 250px !important;
  }
}
</style>